var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.icon && _vm.showing === "svg"
    ? _c(
        "div",
        {
          staticClass: "code-snippet-tab",
          attrs: {
            id: "code-snippet-svg",
            role: "tabpanel",
            "aria-labelledby": "tab-svg",
          },
        },
        [
          _c("wa-code-block", {
            attrs: {
              "add-highlighting": "",
              "allow-shadow-copy": "",
              "copy-text": "Copy Code Snippet",
              "custom-copy-icon": "faClone",
              "copy-tracking-event": "icon_svg_code_copy_button_click",
              "copy-tracking-params": {
                icon_name: _vm.icon.name,
                icon_style: _vm.styling.style,
                icon_family: _vm.styling.family,
              },
              lang: "svg",
              code: _vm.modifiedSvg,
            },
          }),
          _vm._v(" "),
          _c("icon-code-snippet-links", {
            attrs: {
              "has-custom-styling": _vm.hasCustomStyling,
              links: _vm.svgLearnAboutLinks,
              "selected-style": _vm.styling.style,
              version: _vm.version,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }